import React from 'react';
import { CheckboxGroup, MarkupProps } from 'blueprint-form';
import { WEEKDAYS, WEEKDAYS_ABBR } from '../../../libs/time';

export interface WeekdayProps extends MarkupProps {
  abbreviated?: boolean;
  inline?: boolean;
  numItems?: number;
  minItems?: number;
  maxItems?: number;
  isBusinessWeek?: boolean;
}

const WEEKDAYS_OPTIONS = Array.from(WEEKDAYS.keys()).map((i) => ({
  label: WEEKDAYS[i],
  value: i
}));

const WEEKDAYS_ABBR_OPTIONS = Array.from(WEEKDAYS_ABBR.keys()).map((i) => ({
  label: WEEKDAYS_ABBR[i],
  value: i
}));

const GetDayString = (n: number): string => {
  let output = `${n} Days`;
  if (n === 1) {
    output = '1 Day';
  }
  return output;
};

const Weekday = ({
  label,
  name,
  abbreviated,
  inline,
  large,
  disabled,
  numItems,
  minItems,
  maxItems,
  isBusinessWeek
}: WeekdayProps): JSX.Element => {
  if (!label) {
    label = 'Select ';
    if (numItems) {
      label += GetDayString(numItems);
    } else if (minItems && maxItems) {
      label += `${minItems} - ${maxItems} Days`;
    } else if (minItems) {
      label += `at Least ${GetDayString(minItems)}`;
    } else if (maxItems) {
      label += `at Most ${GetDayString(maxItems)}`;
    } else {
      label += 'Days';
    }
    label += ' of the Week';
  }
  name = name || 'days';
  let options = abbreviated ? WEEKDAYS_ABBR_OPTIONS : WEEKDAYS_OPTIONS;
  options = isBusinessWeek ? options.slice(1, 6) : options;
  if (numItems == null && minItems == null && maxItems == null) {
    minItems = 1;
  }
  return (
    <div className={'bp1-weekday' + (inline ? '-inline' : '')}>
      <CheckboxGroup
        label={label}
        name={name}
        inline={inline}
        large={large}
        disabled={disabled}
        numItems={numItems}
        minItems={minItems}
        maxItems={maxItems}
        options={options}
      />
    </div>
  );
};

export default Weekday;
